import "./NewsAppStatisticsOverview.scss";
import NewsAppStatistics from "@/components/News/NewsAppStatistics/NewsAppStatistics.vue";

export default {
  name: "NewsAppStatisticsOverview",
  components: { NewsAppStatistics },
  async mounted() {
    if (!this.$store.state.currentUser) {
      await this.dispatch("getCurrentUser");
    }
    if (!this.isNewsEditor) {
      return await this.$router.push(`/news/`);
    }
  },
  computed: {
    isNewsEditor() {
      return (
        this.isNewsAdmin ||
        this.$store.state.currentUser?.scopes.includes("role:news_editor")
      );
    },
    isNewsAdmin() {
      return (
        this.isAdmin ||
        this.$store.state.currentUser?.scopes.includes("role:news_admin")
      );
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    }
  }
};
